import * as React from "react";
import styled from "styled-components";

const MC = styled.div`
  width: 100%;
  background-color: white;
  padding: 30px 18px;
  box-shadow: rgb(0 0 0 / 10%) 0px 4px 6px -1px, rgb(0 0 0 / 10%) 0px 2px 4px -2px;
`;

const CardHeader = styled.header`
  color: #3d4853;
  background: transparent;
  padding: 12px 0px;
  font-family: "roboto-slab-regular";
  font-size: 16px;
  font-weight: 300;

  a {
    color: #3d4853;
  }
`;

function ModernCard(props) {
  const ta = props.ta ? props.ta : "center";
  const c = props.c ? props.c : "initial";
  const m = props.m ? props.m : "20px 0px";
  const br = props.br ? props.br : '20px';
  return (
    <>
    {props.title && (
      <CardHeader>
        {props.title}
      </CardHeader>
    )}
    <div>
      <MC style={{textAlign:ta, cursor:c, margin:m, borderRadius:br}}>{props.children}</MC>
    </div>
    </>
  );
}

export default ModernCard;



// WEBPACK FOOTER //
// ./app/javascript/components/core/ModernCard.tsx